module.exports = __webpack_public_path__ + "static/media/addressingRequirementsMaterialCard.ff584c54.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/UpZone/addressingRequirementsMaterialCard.png
// module id = 201
// module chunks = 0